<template>
	<section class="page">
		<div class="content-box">
			<div class="operator">
				<div class="operator-col">
					<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
				</div>
				<div class="operator-col">
					<model-preset-input v-model="filterModelPreset"></model-preset-input>
				</div>
			</div>
			<curd-table
				ref="listTable"
				:data-model="editorDataModel"
				:fields="tableFields"
				:kv-filter="kvFilter"
				@doedit="handleEdit($event)"
				list-url="setting/list_models/"
			></curd-table>
		</div>

		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import ModelPresetInput from "@/widgets/Inputs/ModelPresetInput.vue";

export default {
	mixins: [CurdPage, Filters],
	components: {
		ModelPresetInput
	},
	data() {
		return {
			editorDataModel: "Model",
			editorId: "",
			filterModelPreset: {
				name: "",
				_id: ""
			},
			tableFields: [
				{
					name: "name"
				},
				{
					name: "model_preset"
				},
				{
					name: "order_id"
				}
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
					col: 6
				},
				{
					name: "order_id",
					col: 6
				},
				{
					name: "model_preset",
					col: 6
				}
			]
		};
	},
	created() {},
	mounted() {},
	methods: {},
	watch: {
		"filterModelPreset._id": {
			handler(val) {
				let fieldName = "model_preset";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
</script>
